import React from 'react'
import '../digital-portal.scss'
import { essilorLogo } from '@Techedge/digitalportal-styleguide'
import { LuxLoadingCircle } from '@Techedge/digitalportal-wardrobe'

const Logout = (props) => {
    return (
        <div className="portal-container flex-center">
            <img className="logo-bg" src={essilorLogo} />
            <img className="logo" src={essilorLogo} />

            <div>
                <LuxLoadingCircle active={true} />
            </div>
        </div>
    )
}

export default Logout
